// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.gallery-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 20px;
  margin-top: 70px;
  background-color: #fff7d6;
  margin-bottom: -90px;
}

.image-stack {
  position: relative;
  width: 300px;
  height: 440px;
}

.image-item {
  position: absolute;
  width: 230px;
  height: 160px;
  border-radius: 15px;
  cursor: pointer;
  transition: transform 0.3s, z-index 0.3s, box-shadow 0.3s;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-item:nth-child(1) {
  top: -50px;
  left: 0;
  z-index: 4;
}

.image-item:nth-child(2) {
  top: 80px;
  left: 100px;
  z-index: 3;
}

.image-item:nth-child(3) {
  top: 40px;
  left: -130px;
  z-index: 2;
}

.image-item:nth-child(4) {
  top: 200px;
  left: -10px;
  z-index: 1;
}

.image-item:hover {
  transform: scale(1.1);
  z-index: 5;
}

.image-item.active {
  border: 3px solid #ff5757;
}

.info-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-left: 60px;
  width: 40%;
  height: 40%;
}

.info-section h2 {
  font-size: 36px;
  color: #d65a07;
  margin-bottom: 30px;
  margin-left: 150px;
}

.info-section p {
  font-size: 18px;
  line-height: 1.5;
  color: #171313;
  margin-bottom: 110px;
  margin-left: 150px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.modal-content {
  position: relative;
  text-align: center;
  background: white;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  max-width: 90%;
  max-height: 80%;
  overflow: auto;
}

.modal-image {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 15px;
}

.modal-description {
  font-size: 18px;
  color: #333;
  margin-top: 20px;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #b4acac;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 50%;
}

.modal-close:hover {
  background: #706b6b;
}

.second-gallery-container {
  background-color: #f2f2f2;
  padding: 50px 20px;
}

.second-gallery-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.second-left-info {
  flex: 1 1;
  padding-right: 20px;
  text-align: left;
}

.second-left-info h2 {
  font-size: 36px;
  color: #23c7b1;
  margin-bottom: 20px;
}

.second-left-info p {
  font-size: 18px;
  line-height: 1.5;
  color: #090c0c;
  margin: 20px 0;
  max-height: 4.5em;
  overflow: hidden;
}

.second-right-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto auto;
  gap: 20px;
  justify-items: center;
  align-items: center;
}

.second-side-image-container {
  width: 200px;
  height: 200px;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.second-side-image-container:nth-child(1) {
  width: 240px;
  height: 180px;
  margin-right: -30px;
  border-radius: 30%;
}

.second-side-image-container:nth-child(2) {
  width: 200px;
  height: 190px;
  margin-right: -30px;
  border-radius: 30%;
}

.second-side-image-container:nth-child(3) {
  width: 220px;
  height: 170px;
  margin-bottom: -120px;
  border-radius: 30%;
}

.second-side-image-container:nth-child(4) {
  width: 150px;
  height: 150px;
  border-radius: 30%;
}

.second-side-image-container:nth-child(5) {
  width: 180px;
  height: 140px;
  border-radius: 30%;
}

.second-side-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
}

.second-side-image-container:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
}

@media screen and (max-width: 768px) {
  .gallery-container {
    flex-direction: column;
    align-items: center;
    margin: 30px 0;
  }

  .image-item:nth-child(1) {
    top: -50px;
    left: 80px;
    width: 120px;

    z-index: 4;
  }

  .image-item:nth-child(2) {
    top: 90px;
    left: 120px;
    z-index: 3;
    width: 120px;
  }

  .image-item:nth-child(3) {
    top: 50px;
    left: -10px;
    z-index: 2;
    width: 120px;
  }

  .image-item:nth-child(4) {
    top: 200px;
    left: 50px;
    z-index: 1;
    width: 120px;
  }

  .image-stack {
    width: -90%;
    height: auto;
    margin-bottom: 380px;
    margin-top: 250px;
    margin-right: -20px;
  }

  .info-section {
    width: 100%;
    margin-bottom: 10px;
    margin-top: -50px;
    text-align: center;
  }

  .info-section h2 {
    font-size: 20px;
    margin-left: 15px;
    margin-bottom: 10px;
  }

  .info-section p {
    font-size: 16px;
    margin-left: 0;
  }

  .second-gallery-content {
    grid-template-columns: 1fr;
    gap: 0px;
  }

  .second-side-image-container {
    max-width: 100%;
    height: auto;
  }
}

@media screen and (max-width: 480px) {
  .second-gallery-content {
    flex-direction: column;
  }

  .second-left-info {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }

  .second-left-info h2 {
    font-size: 30px;
    color: #23c7b1;
    margin-top: 5px;
  }
  .second-left-info p {
    font-size: 15px;
    line-height: 1.5;
    color: #96a3a1;
    margin: 20px 0;
  }

  .second-right-images {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .second-side-image-container {
    max-width: 100%;
    height: auto;
  }
}

@media screen and (max-width: 480px) {
  .second-gallery-content {
    gap: 15px;
  }

  .second-left-info {
    margin-bottom: 15px;
  }

  .second-right-images {
    gap: 15px;
  }

  .second-side-image-container:nth-child(4) {
    margin-top: 120px;
  }
  .second-side-image-container:nth-child(5) {
    margin-top: 10px;
  }
}
.third-gallery-container {
  background-color: #f2f2f2;
  padding: 50px 20px;
}

.third-gallery-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.third-left-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto auto;
  gap: 20px;
  justify-items: center;
  align-items: center;
}

.third-side-image-container {
  width: 200px;
  height: 200px;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.third-side-image-container:nth-child(1) {
  width: 240px;
  height: 180px;
  margin-right: -30px;
  border-radius: 30%;
}

.third-side-image-container:nth-child(2) {
  width: 200px;
  height: 190px;
  margin-right: -30px;
  border-radius: 30%;
}

.third-side-image-container:nth-child(3) {
  width: 220px;
  height: 170px;
  margin-bottom: -120px;
  border-radius: 30%;
}

.third-side-image-container:nth-child(4) {
  width: 150px;
  height: 150px;
  border-radius: 30%;
}

.third-side-image-container:nth-child(5) {
  width: 180px;
  height: 140px;
  border-radius: 30%;
}

.third-side-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
}

.third-side-image-container:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
}

.third-right-info {
  flex: 1 1;
  padding-left: 20px;
  text-align: left;
}

.third-right-info h2 {
  font-size: 36px;
  color: #23c7b1;
  margin-bottom: 20px;
}

.third-right-info p {
  font-size: 18px;
  line-height: 1.5;
  color: #090c0c;
  margin: 20px 0;
  max-height: 4.5em;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .third-gallery-content {
    flex-direction: column;
    gap: 20px;
  }

  .third-left-images {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .third-side-image-container {
    max-width: 100%;
    height: auto;
  }

  .third-right-info {
    width: 100%;
    padding-left: 0;
    text-align: center;
  }

  .third-right-info h2 {
    font-size: 30px;
  }

  .third-right-info p {
    font-size: 16px;
  }
}

@media screen and (max-width: 480px) {
  .third-gallery-content {
    gap: 15px;
  }

  .third-right-info {
    margin-bottom: 15px;
  }

  .third-left-images {
    gap: 15px;
  }

  .third-side-image-container:nth-child(4) {
    margin-top: 120px;
  }

  .third-side-image-container:nth-child(5) {
    margin-top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Gallery/Gallery.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yDAAyD;EACzD,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,6BAA6B;EAC7B,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,UAAU;IACV,YAAY;;IAEZ,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,UAAU;IACV,UAAU;IACV,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,6BAA6B;EAC7B,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.gallery-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  padding: 20px;\n  margin-top: 70px;\n  background-color: #fff7d6;\n  margin-bottom: -90px;\n}\n\n.image-stack {\n  position: relative;\n  width: 300px;\n  height: 440px;\n}\n\n.image-item {\n  position: absolute;\n  width: 230px;\n  height: 160px;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: transform 0.3s, z-index 0.3s, box-shadow 0.3s;\n  overflow: hidden;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.image-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-item:nth-child(1) {\n  top: -50px;\n  left: 0;\n  z-index: 4;\n}\n\n.image-item:nth-child(2) {\n  top: 80px;\n  left: 100px;\n  z-index: 3;\n}\n\n.image-item:nth-child(3) {\n  top: 40px;\n  left: -130px;\n  z-index: 2;\n}\n\n.image-item:nth-child(4) {\n  top: 200px;\n  left: -10px;\n  z-index: 1;\n}\n\n.image-item:hover {\n  transform: scale(1.1);\n  z-index: 5;\n}\n\n.image-item.active {\n  border: 3px solid #ff5757;\n}\n\n.info-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin-left: 60px;\n  width: 40%;\n  height: 40%;\n}\n\n.info-section h2 {\n  font-size: 36px;\n  color: #d65a07;\n  margin-bottom: 30px;\n  margin-left: 150px;\n}\n\n.info-section p {\n  font-size: 18px;\n  line-height: 1.5;\n  color: #171313;\n  margin-bottom: 110px;\n  margin-left: 150px;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n}\n\n.modal-content {\n  position: relative;\n  text-align: center;\n  background: white;\n  padding: 20px;\n  border-radius: 15px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n  max-width: 90%;\n  max-height: 80%;\n  overflow: auto;\n}\n\n.modal-image {\n  max-width: 100%;\n  max-height: 400px;\n  object-fit: contain;\n  border-radius: 15px;\n}\n\n.modal-description {\n  font-size: 18px;\n  color: #333;\n  margin-top: 20px;\n}\n\n.modal-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: #b4acac;\n  color: white;\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.modal-close:hover {\n  background: #706b6b;\n}\n\n.second-gallery-container {\n  background-color: #f2f2f2;\n  padding: 50px 20px;\n}\n\n.second-gallery-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.second-left-info {\n  flex: 1;\n  padding-right: 20px;\n  text-align: left;\n}\n\n.second-left-info h2 {\n  font-size: 36px;\n  color: #23c7b1;\n  margin-bottom: 20px;\n}\n\n.second-left-info p {\n  font-size: 18px;\n  line-height: 1.5;\n  color: #090c0c;\n  margin: 20px 0;\n  max-height: 4.5em;\n  overflow: hidden;\n}\n\n.second-right-images {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: auto auto;\n  gap: 20px;\n  justify-items: center;\n  align-items: center;\n}\n\n.second-side-image-container {\n  width: 200px;\n  height: 200px;\n  border-radius: 15px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.second-side-image-container:nth-child(1) {\n  width: 240px;\n  height: 180px;\n  margin-right: -30px;\n  border-radius: 30%;\n}\n\n.second-side-image-container:nth-child(2) {\n  width: 200px;\n  height: 190px;\n  margin-right: -30px;\n  border-radius: 30%;\n}\n\n.second-side-image-container:nth-child(3) {\n  width: 220px;\n  height: 170px;\n  margin-bottom: -120px;\n  border-radius: 30%;\n}\n\n.second-side-image-container:nth-child(4) {\n  width: 150px;\n  height: 150px;\n  border-radius: 30%;\n}\n\n.second-side-image-container:nth-child(5) {\n  width: 180px;\n  height: 140px;\n  border-radius: 30%;\n}\n\n.second-side-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 15px;\n}\n\n.second-side-image-container:hover {\n  transform: scale(1.05);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);\n}\n\n@media screen and (max-width: 768px) {\n  .gallery-container {\n    flex-direction: column;\n    align-items: center;\n    margin: 30px 0;\n  }\n\n  .image-item:nth-child(1) {\n    top: -50px;\n    left: 80px;\n    width: 120px;\n\n    z-index: 4;\n  }\n\n  .image-item:nth-child(2) {\n    top: 90px;\n    left: 120px;\n    z-index: 3;\n    width: 120px;\n  }\n\n  .image-item:nth-child(3) {\n    top: 50px;\n    left: -10px;\n    z-index: 2;\n    width: 120px;\n  }\n\n  .image-item:nth-child(4) {\n    top: 200px;\n    left: 50px;\n    z-index: 1;\n    width: 120px;\n  }\n\n  .image-stack {\n    width: -90%;\n    height: auto;\n    margin-bottom: 380px;\n    margin-top: 250px;\n    margin-right: -20px;\n  }\n\n  .info-section {\n    width: 100%;\n    margin-bottom: 10px;\n    margin-top: -50px;\n    text-align: center;\n  }\n\n  .info-section h2 {\n    font-size: 20px;\n    margin-left: 15px;\n    margin-bottom: 10px;\n  }\n\n  .info-section p {\n    font-size: 16px;\n    margin-left: 0;\n  }\n\n  .second-gallery-content {\n    grid-template-columns: 1fr;\n    gap: 0px;\n  }\n\n  .second-side-image-container {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .second-gallery-content {\n    flex-direction: column;\n  }\n\n  .second-left-info {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 10px;\n  }\n\n  .second-left-info h2 {\n    font-size: 30px;\n    color: #23c7b1;\n    margin-top: 5px;\n  }\n  .second-left-info p {\n    font-size: 15px;\n    line-height: 1.5;\n    color: #96a3a1;\n    margin: 20px 0;\n  }\n\n  .second-right-images {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .second-side-image-container {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .second-gallery-content {\n    gap: 15px;\n  }\n\n  .second-left-info {\n    margin-bottom: 15px;\n  }\n\n  .second-right-images {\n    gap: 15px;\n  }\n\n  .second-side-image-container:nth-child(4) {\n    margin-top: 120px;\n  }\n  .second-side-image-container:nth-child(5) {\n    margin-top: 10px;\n  }\n}\n.third-gallery-container {\n  background-color: #f2f2f2;\n  padding: 50px 20px;\n}\n\n.third-gallery-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.third-left-images {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: auto auto;\n  gap: 20px;\n  justify-items: center;\n  align-items: center;\n}\n\n.third-side-image-container {\n  width: 200px;\n  height: 200px;\n  border-radius: 15px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.third-side-image-container:nth-child(1) {\n  width: 240px;\n  height: 180px;\n  margin-right: -30px;\n  border-radius: 30%;\n}\n\n.third-side-image-container:nth-child(2) {\n  width: 200px;\n  height: 190px;\n  margin-right: -30px;\n  border-radius: 30%;\n}\n\n.third-side-image-container:nth-child(3) {\n  width: 220px;\n  height: 170px;\n  margin-bottom: -120px;\n  border-radius: 30%;\n}\n\n.third-side-image-container:nth-child(4) {\n  width: 150px;\n  height: 150px;\n  border-radius: 30%;\n}\n\n.third-side-image-container:nth-child(5) {\n  width: 180px;\n  height: 140px;\n  border-radius: 30%;\n}\n\n.third-side-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 15px;\n}\n\n.third-side-image-container:hover {\n  transform: scale(1.05);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);\n}\n\n.third-right-info {\n  flex: 1;\n  padding-left: 20px;\n  text-align: left;\n}\n\n.third-right-info h2 {\n  font-size: 36px;\n  color: #23c7b1;\n  margin-bottom: 20px;\n}\n\n.third-right-info p {\n  font-size: 18px;\n  line-height: 1.5;\n  color: #090c0c;\n  margin: 20px 0;\n  max-height: 4.5em;\n  overflow: hidden;\n}\n\n@media screen and (max-width: 768px) {\n  .third-gallery-content {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .third-left-images {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .third-side-image-container {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .third-right-info {\n    width: 100%;\n    padding-left: 0;\n    text-align: center;\n  }\n\n  .third-right-info h2 {\n    font-size: 30px;\n  }\n\n  .third-right-info p {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .third-gallery-content {\n    gap: 15px;\n  }\n\n  .third-right-info {\n    margin-bottom: 15px;\n  }\n\n  .third-left-images {\n    gap: 15px;\n  }\n\n  .third-side-image-container:nth-child(4) {\n    margin-top: 120px;\n  }\n\n  .third-side-image-container:nth-child(5) {\n    margin-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
